import { PropsWithChildren } from 'react';
import { Layout } from 'antd';

import Header from './components/Header';
import Footer from './components/Footer';

import styles from './fulllayout.module.css';
import AuthenticatedGuard from '../modules/auth/components/AuthenticatedGuard';
import { Outlet } from 'react-router-dom';

type FullLayoutProps = PropsWithChildren<{}>;

const FullLayout  = ({ children } : FullLayoutProps) => (
  <AuthenticatedGuard>
    <Layout className={styles.app}>
      <Layout>
        <Header />
        <Layout.Content className={`${styles.content}`}>
          {children}
          <Outlet />
        </Layout.Content>
        <Footer/>
      </Layout>
    </Layout>
  </AuthenticatedGuard>
);

export default FullLayout;